import lang from '@/lang'

// Die fuenf groben Kundenstatus — die deutschen Strings SIND die Wire-Werte (Kontrakt:
// dms-s3 CUSTOMER_ISSUE_STATUS; REPO_INTERACTION.md „User-reported analysis problems").
// Sie wohnen HIER und nicht im Duck, damit Anzeige- und Listenkonfiguration den Duck (und damit
// FileService → Store → lists-Duck) nicht zur Laufzeit importieren muessen: genau dieser Kreis
// liess die App am 2026-09-21 beim Start sterben („Cannot read properties of undefined (reading
// 'DOCUMENTS_LIST_TYPE')"). Der Duck re-exportiert beides fuer die bestehenden Importeure.
export const CUSTOMER_ISSUE_STATUSES = ['Eingegangen', 'In Bearbeitung', 'Rückfrage', 'Gelöst', 'Geschlossen'] as const
export type CustomerIssueStatus = typeof CUSTOMER_ISSUE_STATUSES[number]

/**
 * Darstellung der fuenf groben Kundenstatus — Farbe und Beschriftung.
 *
 * Eigenes Modul, weil Liste UND Dialog es brauchen. Vorher lag es in
 * `customer-issues-list.tsx`, und der Dialog importierte es von dort: damit hing der
 * Dialog am `@/redux/store` der Liste und zog den gesamten Ducks-Graphen mit — bis hin
 * zu einem ungetransformten ESM-Paket, an dem die Testsuite gar nicht erst startete.
 * Eine reine Anzeigefunktion darf keinen Store mitbringen.
 */

// Exhaustive over the 5-state customer contract (the Record forces a compile error
// when the contract grows); values the DMS might send in the future still render as
// a neutral chip with their raw label instead of looking broken.
const STATUS_COLOR: Record<CustomerIssueStatus, 'default' | 'info' | 'success' | 'warning'> = {
  Eingegangen: 'default',
  'In Bearbeitung': 'info',
  Rückfrage: 'warning',
  Gelöst: 'success',
  Geschlossen: 'default',
}

export const statusColor = (status: string) => STATUS_COLOR[status as CustomerIssueStatus] ?? 'default'

// The status strings ARE the wire values of the DMS contract, so the display text comes from
// a lookup keyed by them — and an unknown future value still renders raw instead of blank.
export const statusLabel = (status: string) =>
  lang.customerIssues.statusLabels[status as CustomerIssueStatus] ?? status
